import { render, staticRenderFns } from "./OrderItemNoteDeleteForm.vue?vue&type=template&id=4db50684"
import script from "./OrderItemNoteDeleteForm.vue?vue&type=script&lang=js"
export * from "./OrderItemNoteDeleteForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports